export function setUserCookie({ email, name, source }) {
  if (!email) return;
  if (!hasConsent()) return;
  const payload = {
    email: String(email).trim().toLowerCase(),
    name: name ? String(name).trim() : "",
    source: source || "",
    path: typeof window !== "undefined" ? window.location.pathname : "",
    referrer: typeof document !== "undefined" ? document.referrer : "",
    ts: Date.now(),
  };
  const isSecure =
    typeof window !== "undefined" && window.location.protocol === "https:";
  const value = encodeURIComponent(JSON.stringify(payload));
  const cookie = `cargopro_user=${value}; Max-Age=31536000; Path=/; SameSite=Lax${
    isSecure ? "; Secure" : ""
  }`;
  if (typeof document !== "undefined") {
    document.cookie = cookie;
  }
}

export function getUserCookie() {
  if (typeof document === "undefined") return null;
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith("cargopro_user="));
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match.split("=")[1]));
  } catch (e) {
    return null;
  }
}

export function getConsent() {
  if (typeof document === "undefined") return null;
  const row = document.cookie
    .split("; ")
    .find((r) => r.startsWith("cargopro_consent="));
  if (!row) return null;
  return row.split("=")[1];
}

export function setConsent(value) {
  const v = value === "accepted" ? "accepted" : "declined";
  const isSecure =
    typeof window !== "undefined" && window.location.protocol === "https:";
  const cookie = `cargopro_consent=${v}; Max-Age=31536000; Path=/; SameSite=Lax${
    isSecure ? "; Secure" : ""
  }`;
  if (typeof document !== "undefined") {
    document.cookie = cookie;
  }
}

export function hasConsent() {
  return getConsent() === "accepted";
}

export function clearUserCookie() {
  const isSecure =
    typeof window !== "undefined" && window.location.protocol === "https:";
  const cookie = `cargopro_user=; Max-Age=0; Path=/; SameSite=Lax${
    isSecure ? "; Secure" : ""
  }`;
  if (typeof document !== "undefined") {
    document.cookie = cookie;
  }
}
